import { PayoutsListModule } from '@/components/modules/Payouts/PayoutsList/PayoutsList';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_PAYOUTS_LIST: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.PAYOUTS_LIST,
  schemesByRoles: [
    {
      roles: [APP_ROLES.ADMIN, APP_ROLES.SUPER_ADMIN, APP_ROLES.MERCHANT, APP_ROLES.MERCHANT_GROUP, APP_ROLES.PARTNER],
      titleTextId: 'PAYOUTS',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <PayoutsListModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.MERCHANT_GROUP,
              APP_USER_TYPES.MERCHANT,
            ],
          }}
        />
      ),
    },
  ],
};
